const $ = require("jquery");
const _ = require("lodash");

class ItblBadgesSlider {
	constructor (id) {
		this.id = id;
		this.lastTimestamp = null;

		if (this.isAnimated()) {
			this.animationFrame(window.performance.now());
		}
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getAnimationWrap () {
		return this.getRoot().find(
			'[data-component=itbl-badges-slider-animation-wrap]'
		);
	}

	isAnimated () {
		const animatedAttr = this.getRoot().attr("data-animated");
		return animatedAttr && JSON.parse(animatedAttr);
	}

	translateX (percent) {
		this.getAnimationWrap().css("transform", `translateX(${percent}%)`);
	}

	getAnimationWrapYPosition () {
		return this.getAnimationWrap()[0].getBoundingClientRect().y;
	}

	getTranslatePercentage () {
		return 100 * (
			_.clamp(this.getAnimationWrapYPosition() - window.innerHeight / 2, 0, window.innerHeight) / (window.innerHeight / 2)
		);
	}

	animationFrame (timestamp) {
		if (!this.lastTimestamp) {
			this.lastTimestamp = timestamp;
		}

		const dt = (this.lastTimestamp - timestamp) / 1000;
		const turn = this.rotationSpeed * dt;

		const percentage = this.getTranslatePercentage();

		this.translateX(percentage);

		this.lastTimestamp = timestamp;

		window.requestAnimationFrame(ts => this.animationFrame(ts));
	}
}

ItblBadgesSlider.init = () => {
	const objects = [];

	$('[data-component=itbl-badges-slider]').each((i, e) => {
		const id = $(e).attr("id");
		objects.push(new ItblBadgesSlider(id));
	});

	return objects;
}

module.exports = ItblBadgesSlider;
